var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00018,
    cy: 9.02362,
    r: 7.58715,
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.02344V13.0234",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.02344V13.0234",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.02344V13.0234",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.02344L5 9.02344",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.02344L5 9.02344",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.02344L5 9.02344",
    stroke: "currentColor",
    strokeWidth: 1.08388
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.92854ce394f42c0a796f29b5c937c616.svg";
export { ForwardRef as ReactComponent };